import React from 'react';

import { Button } from 'components/ui/button';
import { Dialog } from '@buildoutinc/blueprint-react/ui/Dialog';

interface Props {
  show?: boolean;
  voucherCount?: number;
  onConfirm: () => void;
  onHide: () => void;
}

export default function WarningModal({ onConfirm, onHide, show, voucherCount = 0 }: Props) {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  const plural = voucherCount > 1;

  return (
    <Dialog open={show} onClose={onHide}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Reset Approval Workflow</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <p>
            There {plural ? 'are' : 'is'} currently {voucherCount} voucher{plural ? 's' : ''} pending approval
            that use{plural ? '' : 's'} the current workflow. {plural ? 'These vouchers' : 'This voucher'} will be
            reset to the first step of the workflow, with no approvals.
          </p>
          <p>Are you sure you want to continue?</p>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Cancel>Cancel</Dialog.Cancel>
          <Button label="Yes, Reset Workflow" onClick={handleConfirm} />
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
